"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Flex_1 = require("../Flex");
const Root = (0, styled_1.default)(Flex_1.Flex)({
    gridArea: 'Footer',
    paddingLeft: constants_1.theme.spacing[3],
    paddingRight: constants_1.theme.spacing[3],
    paddingTop: constants_1.theme.spacing[2.5],
    paddingBottom: constants_1.theme.spacing[3],
    gap: constants_1.theme.spacing[2],
    justifyContent: 'end',
    minHeight: 60,
    borderTop: `1px solid ${constants_1.theme.color.borderLight}`,
});
const Footer = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(Root, { children: children });
};
exports.Footer = Footer;
